"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _Elements = require("../Elements");

/* eslint-disable react/prop-types */
var Label = function Label(_ref) {
  var name = _ref.name,
      id = _ref.id,
      className = _ref.className,
      isRequired = _ref.isRequired,
      label = _ref.label,
      htmlFor = _ref.htmlFor,
      onClick = _ref.onClick,
      modifySubstring = _ref.modifySubstring,
      labelWidth = _ref.labelWidth,
      OptionPreview = _ref.OptionPreview;

  var makeLabel = function makeLabel() {
    if (label === undefined || label === null) throw new Error('You forgot to define a label somewhere');

    if (typeof label === 'string') {
      if (isRequired) {
        return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: label
        }, function (text) {
          return /*#__PURE__*/_react["default"].createElement("span", null, "".concat(text, "*"));
        });
      }

      if (modifySubstring) {
        return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: label
        }, function (text) {
          return /*#__PURE__*/_react["default"].createElement("span", null, modifySubstring(text));
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: label
      });
    }

    return /*#__PURE__*/_react["default"].cloneElement(label, {
      isRequired: isRequired
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_Elements.StyledLabel, {
    name: name,
    id: id,
    className: className,
    htmlFor: htmlFor,
    onClick: onClick,
    labelWidth: labelWidth
  }, OptionPreview, makeLabel());
};

var _default = Label;
exports["default"] = _default;